import API from "./api";
import { getSessionId } from "../utils/session";

// ==============================
// CREATE ORDER
// ==============================
export const createOrder = async (payload) => {
  const sessionId = getSessionId();

  const res = await API.post("/orders", payload, {
    headers: {
      "x-session-id": sessionId,
    },
  });

  return res.data.order;
};

// ==============================
// TRACK ORDER (PUBLIC)
// ==============================
export const trackOrder = async (payload) => {
  const res = await API.post("/orders/track", payload);
  return res.data;
};

// ==============================
// TOKEN
// ==============================
const getToken = () => localStorage.getItem("token");

// ==============================
// AUTH HEADER
// ==============================
const getAuthHeader = () => {
  const token = getToken();

  if (!token) throw new Error("No token found. Please login again.");

  return {
    Authorization: `Bearer ${token}`,
  };
};

// ==============================
// GET ALL ORDERS
// ==============================
export const getAllOrders = async () => {
  const res = await API.get("/orders", {
    headers: getAuthHeader(),
  });

  return res.data;
};

// ==============================
// 🔥 GET ORDER BY ID (FIXED FOR YOUR BACKEND)
// ==============================
export const getOrderById = async (id) => {
  const res = await API.get(`/orders/${id}`, {
    headers: getAuthHeader(),
  });

  // IMPORTANT: backend already returns full object
  return res.data;
};